import React, { useCallback, useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { EMPTY_ARRAY, EMPTY_OBJECT, EVENT_LOG_TITLE, EVENT_TYPES } from '../../constants/globalConstants' //, 
import { getPaymentInitials, saveBookingBeforePayment } from '../../redux/actions/paymentActions'
import Loader from '../../components/global/Loader'
import { useNavigate } from 'react-router-dom'
import URL from '../../constants/urls'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'
import BillingInformation from '../../components/paymentComponents/BillingInformation'
import Header from '../../components/global/Header'
import Steps from '../../components/global/Steps'
import { isLoggedIn, isNetworkAvailable, restrictInputValues, validateEmail, validatePhone, validExpiryDate } from '../../utils/helper'
import { addEventLog, getUserIp, storeEventLog, } from '../../redux/actions/eventLogActions' //storeEventLog
import getConfigDetails from '../../services/config'
import { Circles } from 'react-loader-spinner'
import { MaskedInput, createDefaultMaskGenerator } from 'react-hook-mask'
import { ApplyCouponAnalytics } from '../../utils/GoogleAnalytics'
import moment from 'moment'
import useNetwork from '../../hooks/NetworkDetector'
import CONSTANTS from '../../redux/constants'
import useRecaptcha from '../../hooks/useRecaptcha'

const maskGenerator = createDefaultMaskGenerator('9999 9999 9999 9999')
const phoneMaskGenerator = createDefaultMaskGenerator('(999) 999-9999')
const expirymask = createDefaultMaskGenerator('99/99')

function Payment(props) {
	const [isLoading, setIsLoading] = useState(true)
	const [res, setRes] = useState('')
	const [url, setUrl] = useState('')
	const [guid, setGuid] = useState(EMPTY_OBJECT)
	const [eventRates, setEventRates] = useState(EMPTY_OBJECT)
	const [eventDetails, setEventDetails] = useState(EMPTY_OBJECT)
	const [eventType, setEventType] = useState()
	const [message, setMessage] = useState()
	const [discount, setDiscount] = useState(null)
	const [inputType, setInputType] = useState('password')
	const [coupon, setCoupon] = useState('')
	const [couponButton, setCouponButton] = useState(false)
	const [isPromoValid, setIsPromoValid] = useState(false)
	const [promoLoader, setPromoLoader] = useState(false)
	const [loader, setLoader] = useState(true)
	const [eyeIcon, setEyeIcon] = useState(faEye)
	const [value, setValue] = useState('')
	const [phone, setPhone] = useState('')
	const [name, setName] = useState('')
	const [email, setEmail] = useState('')
	const [cvv, setCvv] = useState('')
	const [expiryMonth, setExpiryMonth] = useState('')
	const [expiryYear, setExpiryYear] = useState('')
	const [bookDirect, setBookDirect] = useState(false)
	const [fisrtLoad, setIsFirstLoad] = useState(false)
	const [beforeApiLoad, setBeforeApiLoad] = useState(false)
	const [expiryTime, setExpiryTime] = useState(900000)
	const [errorMessage, setErrorMessage] = useState('')
	const [cvvErrorMessage, setCvvErrorMessage] = useState('')
	const [bookingDisabled, setBookingDisabled] = useState(true)
	// const [cardExpiryMessage, setCardExpiryMessage] = useState('')
	const [expiry, setExpiry] = useState('')
	// const [hideBookingButton, setHideBookingButton] = useState(false)

	const { dispatch } = props
	const navigate = useNavigate()
	const formRef = useRef()
	const sessionFetchedRef = useRef(false)
	const isOnline = useNetwork()
	// ===== reCAPTCHA v3 Hook =====
	const { getToken, isReady } = useRecaptcha()
	// ===== End reCAPTCHA Hook =====


	useEffect(() => {
		setValue('')
		setPhone('')
		setErrorMessage('')
		setCvvErrorMessage('')
		localStorage.setItem('name', '')
		localStorage.setItem('email', '')
		localStorage.setItem('phone', '')
		localStorage.setItem('card_date_expiry_month', '')
		localStorage.setItem('card_date_expiry_year', '')
		localStorage.setItem('card_pan', '')
		localStorage.setItem('CardNumberLast4', '')
		window.scrollTo(0, 0)

		setTimeout(() => {
			setExpiryTime(0)
		}, 900000)

		setIsLoading(true)
		const eventData = JSON.parse(localStorage.getItem(EVENT_TYPES?.EVENT))
		setEventDetails(eventData)
		const User_ip = localStorage.getItem('user_ip')

		if (User_ip == '' || eventData?.slug == '') {
			navigate(URL.HOME)
		}

		dispatch(getUserIp()).then((res) => {
			localStorage.setItem('user_ip', res.IPv4)
		}).catch((err) => {
			console.log(err)
		})

		const user_ip = localStorage.getItem('user_ip')

		const payload = {
			'error_message': 'null',
			'event_name': EVENT_LOG_TITLE?.PAYMENT_LOADED,
			'user_ip': user_ip ? user_ip : 'NA',
			'facility_id': getConfigDetails.FACILITY_ID
		}
		dispatch(storeEventLog(payload)).then(() => {
		}).catch(() => {
		})

		if (!eventData || eventData?.slug == '') {
			navigate(URL.HOME)
		}
		setEventType(localStorage.getItem('event_type'))
	}, EMPTY_ARRAY)

	// Loads the planet-payment-session, attaching a reCAPTCHA token (action: 'session')
	const loadPaymentSession = useCallback((recaptcha_token) => {
		const eventData = JSON.parse(localStorage.getItem(EVENT_TYPES?.EVENT))
		const event_type = localStorage.getItem('event_type')
		const event_id = eventData?.id
		const paymentSessionPayload = {
			is_first_load: 1,
			'facility_id': getConfigDetails.FACILITY_ID,
			'rate_id': event_type == EVENT_TYPES?.EVENT ? '' : event_id,
			'event_id': event_type == EVENT_TYPES?.EVENT ? event_id : '',
			'client_id': getConfigDetails?.CLIENT_SECRET,
			'recaptcha_token': recaptcha_token,
		}
		dispatch(getPaymentInitials(paymentSessionPayload)).then((response) => {

			if (response?.data) {
				setExpiryTime(900000)
				setIsLoading(false)
				setIsFirstLoad(true)
				setLoader(false)
				setUrl(response?.data?.api_url)
				setRes(response?.data?.ipgSession)
				setGuid(response?.data?.guid)
				setEventRates(response?.data)
				localStorage.setItem('paymentSession', JSON.stringify(response?.data))
				if (Number(response?.data?.amount) == 0) {
					setBookDirect(true)
					// setHideBookingButton(true)
					localStorage.setItem('promo_applied', 2)

				} else {
					setBookDirect(false)
					// setHideBookingButton(false)
				}
				setBookingDisabled(false)
			} else {
				setExpiryTime(900000)
				setIsLoading(false)
				setIsFirstLoad(true)
				setLoader(false)
				setUrl(null)
				setRes(null)
				setGuid(null)
				setEventRates(null)
				localStorage.setItem('paymentSession', 'null')
				if (Number(response?.data?.amount) == 0) {
					setBookDirect(true)
					// setHideBookingButton(true)
					localStorage.setItem('promo_applied', 2)

				} else {
					setBookDirect(false)
					// setHideBookingButton(false)
				}
				setBookingDisabled(true)
				setErrorMessage(response?.errors?.message ? response?.errors?.message : 'There is some error, Please try again later!')
			}


		}).catch((err) => {
			setBookingDisabled(true)
			setErrorMessage(err?.errors?.message ? err?.errors?.message : 'There is some error, Please try again later!')
			// console.log(err)
		})
	}, [dispatch])

	// Fetch the payment session once reCAPTCHA is ready, with a fallback so the
	// page never hangs if reCAPTCHA fails to load.
	useEffect(() => {
		if (sessionFetchedRef.current) return
		let cancelled = false
		const run = async () => {
			if (isReady) {
				sessionFetchedRef.current = true
				const token = await getToken('session')
				if (cancelled) return
				loadPaymentSession(token)
			}
		}
		run()
		const fallback = setTimeout(() => {
			if (!sessionFetchedRef.current) {
				sessionFetchedRef.current = true
				loadPaymentSession(null)
			}
		}, 6000)
		return () => { cancelled = true; clearTimeout(fallback) }
	}, [isReady, getToken, loadPaymentSession])

	const handleInputChange = (e) => {
		const { name, value } = e.target
		if (name == 'coupon') {
			setCoupon(value)
		}
		if (name == 'name') {
			setName(value)
		}

		if (name == 'email') {
			setEmail(value)
		}

		if (name == 'card_card_security_cvx_2') {
			setCvv(value)
		}
		if (name == 'card_date_expiry_month') {
			setExpiryMonth(value)
			setCvvErrorMessage('')
		}
		if (name == 'card_date_expiry_year') {
			setExpiryYear(value)
			setCvvErrorMessage('')
		}

		localStorage.setItem([name], value.trim())

		if (name == 'card_card_security_cvx_2') {
			const re = /^[0-9\b]+$/
			// if value is not blank, then test the regex
			if (value !== '') {
				re.test(value)
			}
		}
	}
	const handleCardInputChange = (value) => {
		setValue(value)
		localStorage.setItem('card_pan', value.substring(12, 16))
	}
	const handlePhoneChange = (value) => {
		setPhone(value.trim())
		localStorage.setItem('phone', value.trim())
	}

	const handleCVVVisibility = (e, type) => {
		if (type == 'text') {
			setInputType('password')
			setEyeIcon(faEye)
		} else {
			setInputType('text')
			setEyeIcon(faEyeSlash)
		}
	}
	const ClickApplyCouponAnalytics = (data) => {
		ApplyCouponAnalytics(data)

	}

	const handleCouponCode = async () => {
		const event_id = localStorage.getItem('event_id')
		const email = localStorage.getItem('email')
		if (isOnline) {
			if (coupon != '') {
				setCouponButton(true)
				setPromoLoader(true)
				setLoader(true)
				if (email && validateEmail(email) && validatePhone(phone)) {

					const recaptcha_token = await getToken('session')
					const paymentSessionPayload = {
						'facility_id': getConfigDetails.FACILITY_ID,
						'rate_id': eventType == EVENT_TYPES?.EVENT ? '' : eventDetails?.id,
						'event_id': eventType == EVENT_TYPES?.EVENT ? eventDetails?.id : '',
						'promocode': coupon,
						'client_id': getConfigDetails?.CLIENT_SECRET,
						'email': localStorage.getItem('email'),
						'recaptcha_token': recaptcha_token,
					}
					dispatch(getPaymentInitials(paymentSessionPayload)).then((response) => {
						if (response?.data) {
							setBookingDisabled(false)
							setExpiryTime(900000)

							if (response?.data?.amount == 0) {
								setBookDirect(true)
								// setHideBookingButton(false)
								localStorage.setItem('promo_applied', 1)

							} else {
								setBookDirect(false)
								// setHideBookingButton(false)
							}
							setPromoLoader(false)
							setIsPromoValid(true)
							setMessage('Coupon Code Applied Successfully!')
							const discount = response?.data?.discounted_amount
							setDiscount(discount)
							setIsLoading(false)
							setIsFirstLoad(true)
							setLoader(false)
							setUrl(response?.data?.api_url)
							setRes(response?.data?.ipgSession)
							setGuid(response?.data?.guid)
							setEventRates(response?.data)
							localStorage.setItem('paymentSession', JSON.stringify(response?.data))
						} else {
							handleCouponRemove(true)
							setLoader(false)
							setPromoLoader(false)
							setIsPromoValid(false)
							localStorage.setItem('couponApplied', `Yes, but ${response?.errors?.message}`)
							setMessage(response?.errors?.message ? response?.errors?.message : 'There is some error, Please try again later!')
							setBookingDisabled(true)
						}

					}).catch((err) => {
						handleCouponRemove(true)
						setLoader(false)
						setPromoLoader(false)
						setIsPromoValid(false)
						localStorage.setItem('couponApplied', 'Yes, but something went wrong and didn\'t get any discount')
						setMessage(err?.errors?.message ? err?.errors?.message : 'There is some error, Please try again later!')
						setBookingDisabled(true)
					})
				} else {
					setLoader(false)
					setPromoLoader(false)
					setIsPromoValid(false)
					localStorage.setItem('couponApplied', 'Yes, but without user details, Didn\'t get any discount')
					setMessage('Please enter valid user details')
				}
			} else {
				setLoader(false)
				setIsPromoValid(false)
				setMessage('Please enter a Promocode')
			}
			const ApplyCouponAnalyticsPayloads = {
				event_id: event_id,
				facility_id: getConfigDetails.FACILITY_ID,
				'promocode': coupon
			}
			ClickApplyCouponAnalytics(ApplyCouponAnalyticsPayloads)
		}
	}
	const handleCouponRemove = async (isCalledfromApply) => {
		if (isOnline) {
			setLoader(true)
			setBookDirect(false)
			// setHideBookingButton(false)
			setPromoLoader(true)
			localStorage.setItem('coupon', '')
			localStorage.setItem('couponApplied', 'Yes, but removed')
			localStorage.setItem('promo_applied', '')
			setCoupon('')
			// const event_id = localStorage.getItem('event_id')

			const recaptcha_token = await getToken('session')
			const paymentSessionPayload = {
				is_first_load: 1,
				'facility_id': getConfigDetails.FACILITY_ID,
				'rate_id': eventType == EVENT_TYPES?.EVENT ? '' : eventDetails?.id,
				'event_id': eventType == EVENT_TYPES?.EVENT ? eventDetails?.id : '',
				// 'client_id' : getConfigDetails?.clientSecret,
				'recaptcha_token': recaptcha_token,
			}
			dispatch(getPaymentInitials(paymentSessionPayload)).then((response) => {
				setExpiryTime(900000)
				setBookingDisabled(false)
				setLoader(false)
				setIsFirstLoad(true)
				setPromoLoader(false)
				setRes(response?.data?.ipgSession)
				setUrl(response?.data?.api_url)
				setGuid(response?.data?.guid)
				setEventRates(response?.data)
				localStorage.setItem('paymentSession', JSON.stringify(response?.data))
				setDiscount(null)
				if (isCalledfromApply != 1) {
					setMessage(null)
				}
				setCoupon('')
				setCouponButton(false)
				if (Number(response?.data?.amount) == 0) {
					setBookDirect(true)
					// setHideBookingButton(true)
					localStorage.setItem('promo_applied', 2)

				} else {
					setBookDirect(false)
					// setHideBookingButton(false)
				}
			}).catch((err) => {
				setBookingDisabled(true)
				setMessage(err?.errors?.message ? err?.errors?.message : 'There is some error, Please try again later!')
				console.log(err)
			})
		}
	}

	const logSubmit = async (e) => {
		if (isOnline && !bookingDisabled) {
			if (!loader) {
				if (isNetworkAvailable()) {
					setErrorMessage('')

					if (expiryTime > 0) {
						const event = e
						const form = formRef.current
						if (form && res != '' && res != null) {
							const formValues = {
								name: localStorage.getItem('name'),
								email: localStorage.getItem('email'),
								phone: localStorage.getItem('phone'),
								card_pan: localStorage.getItem('card_pan'),
								card_expiry_month: localStorage.getItem('card_date_expiry_month'),
								card_expiry_year: localStorage.getItem('card_date_expiry_year'),
								event: localStorage.getItem(EVENT_TYPES?.EVENT),
								couponFilled: localStorage.getItem('coupon') ? 'Yes' : 'No',
								couponApplied: localStorage.getItem('couponApplied') ? localStorage.getItem('couponApplied') : 'No',
								coupon: localStorage.getItem('coupon') ? localStorage.getItem('coupon') : 'NIL',
								user: isLoggedIn() ? JSON.parse(localStorage.getItem('userData'))?.user : ''
							}

							const payload = {
								'error_message': JSON.stringify(formValues),
								'facility_id': getConfigDetails.FACILITY_ID,
								'event_name': EVENT_LOG_TITLE?.PAYMENT,
								'user_id': 0,
								'user_ip': localStorage.getItem('user_ip')
							}
							const get_event_type = localStorage.getItem('event_type')
							const event_data = JSON.parse(localStorage.getItem('event'))
							const paymentSessionData = JSON.parse(localStorage.getItem('paymentSession'))
							const userEvents = localStorage.getItem('userChooseEvents')
							const beforePaymentPayload = {
								'facility_id': getConfigDetails.FACILITY_ID,
								'name': formValues.name,
								'phone': formValues.phone,
								'email': formValues.email,
								'total': paymentSessionData?.amount,
								'rate_id': get_event_type == EVENT_TYPES?.EVENT ? '' : event_data?.id,
								'event_id': eventType == EVENT_TYPES?.EVENT ? event_data?.id : '',
								'event_category_id': (get_event_type == EVENT_TYPES?.EVENT) ? event_data?.event_category_event?.event_category_id : event_data?.event_category_id,
								'arrival': (get_event_type == EVENT_TYPES?.EVENT) ? event_data?.event_arrival : event_data?.all_event[0]?.event_arrival,
								'event_type': get_event_type,
								'is_full_season': (get_event_type != EVENT_TYPES?.EVENT) ? event_data?.is_full_season : '',
								'reference': paymentSessionData?.reference,
								'ex_month': formValues?.card_expiry_month,
								'ex_year': formValues?.card_expiry_year,
								'user_consent': 1,
								'user_id': formValues?.user?.id,
								'event_ids': get_event_type !== EVENT_TYPES?.EVENT && get_event_type !== EVENT_TYPES?.PARTY_PASS ? userEvents?.split(',') : '',

							}
							if (validateEmail(email) && validatePhone(phone)) {
								if (name != '' && name != null && email != '' && email != null && value != '' && value != null && (value.length >= 14 || value.length <= 16) && cvv != '' && cvv != null && (cvv.length == 3 || cvv.length == 4) && expiryMonth != '' && expiryMonth != null && expiryYear != '' && expiryYear != null && phone != '' && phone != null) {
									const currentDate = new Date(moment(new Date()).format('YYYY'), moment(new Date()).format('MM') - 1)
									const cardExpiry = new Date(moment(expiryYear, 'YY').format('YYYY'), expiryMonth - 1)
									if (currentDate <= cardExpiry) {
										setCvvErrorMessage('')

										// ===== reCAPTCHA v3: Generate Token for Checkout =====
										const recaptcha_token = await getToken('before_payment')
										if (!recaptcha_token) {
											setErrorMessage('Security verification failed. Please try again.')
											return
										}
										beforePaymentPayload.recaptcha_token = recaptcha_token
										// ===== End reCAPTCHA =====

										setBeforeApiLoad(true)
										dispatch(saveBookingBeforePayment(beforePaymentPayload)).then((res) => {

											if (res?.data?.mer_reference != '' && res?.data?.mer_reference != null && res?.data?.mer_reference != undefined) {
												localStorage.setItem('reservation_id', res?.data?.id)
												setBeforeApiLoad(false)
												if (event) {
													const formData = new FormData(formRef.current)
													const data = Object.fromEntries(formData.entries())
													dispatch(addEventLog(data, CONSTANTS.FORM_SUBMIT_DATA))
													form.submit()
												}
											}
											dispatch(storeEventLog(payload))
											formRef.current = false
										}).catch(() => {
											setMessage('There is some error, please try again in sometime!')
											dispatch(storeEventLog(payload))
											formRef.current = false
										})
									} else {
										setCvvErrorMessage('Please select correct expiry date or another card.')
									}
								}
								else {
									document.getElementById('ipg_form').reportValidity()

									// setError(true)
									if (name == '' || name == null) {
										document.getElementById('name').setCustomValidity('Please enter your name.')
									} else if (phone == '' || phone == null || phone.length < 10) {
										document.getElementById('phone').setCustomValidity('Please enter a valid phone number.')
									} else if (email == '' || email == null) {
										document.getElementById('email').setCustomValidity('Please enter a valid email id.')
									}
									else if (value == '' || value == null || value.length < 14 || value.length > 16) {
										document.getElementById('card_pan').setCustomValidity('Please enter a valid card.')
									}
									else if (cvv == '' || cvv == null || cvv.length < 3 || cvv.length > 4) {
										document.getElementById('card_card_security_cvx_2').setCustomValidity('Please enter a valid CVV number.')
									}
									else if (expiryMonth == '' || expiryMonth == null) {
										document.getElementById('expiryMonth').setCustomValidity('Please enter expiry month.')
									} else if (expiryYear == '' || expiryYear == null) {
										document.getElementById('expiryYear').setCustomValidity('Please enter expiry year.')
									}
								}
							} else {
								if (!validateEmail(email) && !validatePhone(phone)) {
									setErrorMessage('Please enter a valid email & phone number!')
								} else if (!validateEmail(email)) {
									setErrorMessage('Please enter a valid email!')
								} else if (!validatePhone(phone)) {
									setErrorMessage('Please enter a valid phone number!')
								}
							}
						}
					} else {
						setErrorMessage('Payment Session Expired, Please refresh the page or try again!')
					}
				} else {
					setErrorMessage('Please check the Internet Connection!')
				}
			}
		}
	}

	const handleExpiryChange = (value) => {

		let expiryDateCheck = validExpiryDate(value)
		if (value.length == 4 && !expiryDateCheck) {
			// setCardExpiryMessage('Enter a valid expire date')
		} else {
			// setCardExpiryMessage('')
			setExpiry(value?.trim())
			setExpiryMonth(value.substring(0, 2))
			setExpiryYear(value.substring(2))
			localStorage.setItem('card_date_expiry_month', value.substring(0, 2))
			localStorage.setItem('card_date_expiry_year', value.substring(2))
		}
	}

	const handleBookDirect = (e) => {
		if (isOnline && !bookingDisabled) {
			e.preventDefault()
			if (!loader) {
				if (isNetworkAvailable()) {
					setErrorMessage('')

					if (res != '' && res != null) {
						if (name != '' && name != null && phone != '' && phone != null && phone.length >= 10) {
							logSubmit()
							navigate(URL.PAYMENT_SUCCESS)
						}
						else {
							document.getElementById('ipg_form').reportValidity()
							if (name == '' || name == null) {
								document.getElementById('name').setCustomValidity('Please enter your name.')
							} else if (phone == '' || phone == null || phone.length < 10) {
								document.getElementById('phone').setCustomValidity('Please enter a valid phone number.')
							}
						}
					}
				} else {
					setErrorMessage('Please check the Internet Connection!')
				}
			}
		}
	}

	return (
		isLoading ? <Loader /> : <div>
			<Header />
			<main>
				<Steps
					page='payment'
				/>
				<BillingInformation
					eventType={eventType}
					eventDetails={eventDetails}
					eventRates={eventRates}
					discount={discount}
					loader={loader}
					fisrtLoad={fisrtLoad}

				/>

				{/* <div className="container">
					<a href="#"  className="btn btn-light"> Checkout as Guest User</a> &nbsp;  <a href="#" className="btn btn-primary " data-bs-toggle="modal" data-bs-target="#exampleModal"> Already User? Sign-In</a>
					<hr/>  
				</div> */}


				<div className="container">
					{/* <form action={url} ref={formRef} id='ipg_form' name='ipg_form'  method='post' onSubmit={(e) => logSubmit(e)}> */}
					<form action={url} ref={formRef} id='ipg_form' target="_top" name='ipg_form' method='post' >
						<div className="row ">

							<div className='col-12 col-md-6 col-sm-8'>
								<div className=' d-flex '><label className="mb-3"><b>Personal Information</b></label></div>
								<div className='row'>
									<div className="col-12 mb-2">
										<input
											type="text"
											name="name"
											id="name"
											className="form-control"
											placeholder="Name"
											pattern="^([A-Za-z]+[,.]?[ ]?|[A-Za-z]+['-]?)+$"
											required
											onInvalid={e => e.target.setCustomValidity('Please enter your name')}
											onInput={e => e.target.setCustomValidity('')}
											onChange={handleInputChange} />
									</div>
									<div className="col-sm-6 col-12 mb-2">
										<input
											type="email"
											name="email"
											className="form-control"
											required
											pattern='[^@]+@[^@]+\.[a-zA-Z]{2,6}'
											title="example@mail.xyz"
											maxLength='40'
											placeholder="Email Address"
											onInvalid={e => e.target.setCustomValidity('Please enter email address')}
											onInput={e => e.target.setCustomValidity('')}
											onChange={handleInputChange} />
									</div>
									<div className=" col-12 col-sm-6 mb-2">
										{/* <input 
											type="text" 
											name="phone" 
											className="form-control"  
											required
											pattern="[0-9 ]{}"
											maxLength={12}
											minLength={10}
											title="Please enter a valid phone number"
											onInvalid={e => e.target.setCustomValidity('Please enter phone number')}
											onInput={e => e.target.setCustomValidity('')}
											placeholder="Phone Number"
											onChange={handleInputChange}/> */}
										<MaskedInput
											maskGenerator={phoneMaskGenerator}
											value={phone}
											type="text"
											name="phone"
											id="phone"
											className="form-control"
											required
											// pattern="[0-9 \\-\(\)\]{14}"
											maxLength={14}
											minLength={14}
											title="Please enter a valid phone number"
											onInvalid={e => e.target.setCustomValidity('Please enter phone number')}
											onInput={e => e.target.setCustomValidity('')}
											placeholder="Phone Number"
											onChange={handlePhoneChange} />
									</div>
								</div>
							</div>
							<div className='col-12 col-md-6 col-sm-8'>
								<div className=' d-flex '><label className="mb-3 "><b>Payment Details</b></label></div>
								<div className="mb-2">
									<MaskedInput
										maskGenerator={maskGenerator}
										value={value}
										type="text"
										name="card_pan"
										id="card_pan"
										required={bookDirect ? false : true}
										pattern="[0-9 ]{18,19}"
										maxLength='19'
										minLength='18'
										title="Card no. should be 15-16 digit numberic"
										className="form-control"
										onChange={handleCardInputChange}
										onInvalid={e => e.target.setCustomValidity('Please enter a valid card number')}
										onInput={e => e.target.setCustomValidity('')}
										placeholder="Card Number"
									/>
									{/* <input 
										type="text" 
										name="card_pan" 
										required
										pattern="[0-9]{16}"
										maxLength='16'
										minLength='16' 
										title="Card no. should be 16 digit numberic"
										className="form-control"  
										onChange={handleInputChange}
										onInvalid={e => e.target.setCustomValidity('Please enter CC card number')}
										onInput={e => e.target.setCustomValidity('')}
										placeholder="Card Number"/> */}
								</div>
								<div className="row">
									<div className="col-sm-6">
										<div className="input-group mb-2">
											<input
												type={inputType}
												className="form-control"
												id='card_card_security_cvx_2'
												required={bookDirect ? false : true}
												maxLength='4'
												minLength='3'
												inputMode='numeric'
												name='card_card_security_cvx_2'
												placeholder="CVV"
												onChange={handleInputChange}
												onInvalid={e => e.target.setCustomValidity('Please enter CVV code')}
												onInput={e => e.target.setCustomValidity('')}
												onKeyPress={e => restrictInputValues(e)}
												autoComplete="new-password" />
											<span className="cursor input-group-text" id="basic-addon1" onClick={(e) => handleCVVVisibility(e, inputType)}><FontAwesomeIcon icon={eyeIcon} /></span>
										</div>

									</div>
									<div className="col-sm-4 col-6 mb-2 d-none">
										<select
											name='card_date_expiry_month'
											id="expiryMonth"
											required={bookDirect ? false : true}
											className="form-select invisible"
											onInvalid={e => e.target.setCustomValidity('Please select expiry month')}
											onInput={e => e.target.setCustomValidity('')}
											onChange={handleInputChange}
										>
											<option value={expiryMonth} selected></option>
											{/* <option value="">Expiry Month</option>
											{EXPIRY_MONTHS.map((item, key) => <option key={key} value={item}>{item}</option>)} */}
										</select>
									</div>

									<div className="col-sm-4 col-6 mb-2 d-none">
										<select
											name='card_date_expiry_year'
											id='expiryYear'
											required={bookDirect ? false : true}
											className="form-select invisible"
											onInvalid={e => e.target.setCustomValidity('Please select expiry year')}
											onInput={e => e.target.setCustomValidity('')}
											onChange={handleInputChange}
										>
											<option value={expiryYear} selected></option>
											{/* <option value="">Expiry Year</option>
											{EXPIRY_YEARS.map((item, key) => <option key={key} value={item.val}>{item.label}</option>)} */}
										</select>
									</div>
									<div className="col-sm-6 col-md-6">
										<div className="mb-3">
											<MaskedInput
												maskGenerator={expirymask}
												value={expiry}
												type="text"
												autoComplete="off"
												name="expiration_date"
												id="expiration_date"
												required={true}
												pattern="[0-9 ]{4}"
												maxLength='5'
												minLength='4'
												title="Enter a valid expiry date"
												className="form-control"
												onChange={handleExpiryChange}
												onInvalid={e => e.target.setCustomValidity(expiry == '' ? 'the field is required' : 'Please enter a valid expiry date')}
												onInput={e => e.target.setCustomValidity('')}
												placeholder="MM/YY"
											/>

											{/* <span className="form-text text-danger h-40">{formError == 'pass' ? !formData?.expiration_date ? 'This field is required' : '' : ''}</span> */}
											{/* <span className="form-text text-danger h-40">{formError == 'pass' ? formData?.expiration_date && (formData?.expiration_date?.length<4 || formData?.expiration_date?.length>5)? 'Enter a valid expiry date ':'' : ''}</span> */}
											{/* <span className='form-text text-danger h-40'>{cardExpiryMessage}</span> */}

										</div> </div>
									<span className="text-danger cvvError mb-2"><b>{cvvErrorMessage}</b></span>
								</div>
								<input type='hidden' name='XXX_IPG_XXX' id='XXX_IPG_XXX' value='confirm' />
								<input type='hidden' name='XXX_IPGTRXNO_XXX' id='XXX_IPGTRXNO_XXX' value={guid} />
								<input type='hidden' name='XXX_IPGSESSION_XXX' id='XXX_IPGSESSION_XXX' value={res}></input>
							</div>

						</div>
						<div className="row">
							<label className="mb-3 col-12 "><b>Apply Coupon</b></label>
							<div className='col-sm-6'>
								<div className="row">
									<div className="col ">
										<div className="input-group">
											<input type="text" name="coupon" value={coupon} className='form-control' placeholder="Enter Your Coupon Code" aria-label="coupon" aria-describedby="basic-addon1" onChange={handleInputChange} />
											{couponButton && <span className="cursor input-group-text" id="basic-addon1" onClick={handleCouponRemove}>X</span>}
										</div>
									</div>
									<div className="col-auto">
										<button className="btn btn-primary" type="button" onClick={handleCouponCode}>Apply</button>
									</div>
									<span className='promo-msg '>{promoLoader ?
										<span className=' mt-2 d-flex'><Circles
											height="20"
											width="20"
											color="#060D63"
											ariaLabel="circles-loading"
											visible={true}
										/><span className='ms-2'>Loading...</span></span> : <span className={isPromoValid ? 'text-success' : 'text-danger'}>{message}</span>}</span>


								</div>

								<div className="row">
									<span className="text-danger mb-2"><b>{errorMessage}</b></span>
									<div className='col-sm-4 col-12'>
										{/* {!hideBookingButton ? */}
										{bookDirect ?
											<button
												type='button'
												id="submit"
												onClick={(e) => handleBookDirect(e)}
												className="btn btn-danger w-100 px-4"
												disabled={bookingDisabled || !isReady}>
												Book
											</button> :
											<button
												type='button'
												className="btn btn-danger px-4 d-inline-flex"
												onClick={(e) => logSubmit(e)}
												disabled={bookingDisabled || !isReady}>
												{!beforeApiLoad && !bookingDisabled ? 'Book' :
													<span className='d-inline-flex justify-center'>
														Please wait... <span className=' ms-2'>
															<Circles
																height="20"
																width="20"
																color="#ffffff"
																ariaLabel="circles-loading"
																visible={true}
															/>
														</span>
													</span>
												}
											</button>}


										{/* {bookDirect ? <button type='button' id="submit" onClick={(e) => handleBookDirect(e)} className="btn btn-danger w-100 px-4">Book</button> : <button type='submit' className="btn btn-danger w-100 px-4">Book</button>} */}
									</div>
								</div>
							</div>
						</div>
					</form>
				</div>
			</main>

		</div>

	)

}


Payment.propTypes = {
	dispatch: PropTypes.func,
	data: PropTypes.object,
	loader: PropTypes.bool
}


Payment.defaulProps = {
	dispatch: noop,
	data: EMPTY_OBJECT,
	loader: true
}

function mapStateToProps({ paymentReducer }) {
	return {
		data: paymentReducer,
		loader: paymentReducer
	}
}
export default connect(mapStateToProps)(Payment)

